import { useMemo } from "react";
import { LocationService } from "@/services/LocationService";
import { useQuery } from "@tanstack/react-query";

export function useLocationQuery(locationId: string | undefined) {
  const locationService = useMemo(() => new LocationService(), []);

  return useQuery({
    queryKey: ["location", locationId],
    queryFn: () => locationService.getLocationById(locationId!),
    enabled: !!locationId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff up to 30 seconds
  });
}
